import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { useFragment } from "react-relay";
import { VideoElementPart_ContentSubmissionFragment$key } from "@generated/VideoElementPart_ContentSubmissionFragment.graphql";
import { VideoElementDisplay } from "./VideoElementDisplay.component";
import { ProjectContentElementContainer } from "../../../../infecto-lms-webapp-impl/containers/ProjectContentElement.container";
import { isWissenwirktApp } from "../../../utils/isWissenwirktApp";
import { SubmitDisplayElementButton } from "../SubmitDisplayElementButton.component";

const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment VideoElementPart_ContentSubmissionFragment on ContentSubmission {
		id
		definition {
			... on ActiveELearningContentSubmissionDefinition {
				currentElementState {
					element {
						...VideoElementDisplay_VideoLearnElementFragment
					}
				}
			}
		}
		...ContentElementContainer_ContentSubmissionFragment
		...SubmitDisplayElementButton_ContentSubmissionFragment
		...ProjectContentElementContainer_ContentSubmissionFragment
	}
`;

interface OwnProps {
	contentSubmissionFragmentRef: VideoElementPart_ContentSubmissionFragment$key;
}

export function VideoElementPart({ contentSubmissionFragmentRef }: OwnProps) {
	const contentSubmission = useFragment<VideoElementPart_ContentSubmissionFragment$key>(
		CONTENT_SUBMISSION_FRAGMENT,
		contentSubmissionFragmentRef,
	);

	if (!contentSubmission.definition.currentElementState?.element) return null;

	return (
		<ProjectContentElementContainer
			contentSubmissionFragmentRef={contentSubmission}
			nextButton={<SubmitDisplayElementButton contentSubmissionFragmentRef={contentSubmission} />}
		>
			<VideoElementDisplay
				isShowingTitle={!isWissenwirktApp}
				videoElementFragmentRef={contentSubmission.definition.currentElementState.element}
			/>
		</ProjectContentElementContainer>
	);
}
